import React, { Component } from 'react';
import { connect } from 'react-redux';
import JsxHelper from '../Helpers/JsxHelper';
import { link_click } from '../redux/actions';
import RoleService from '../Services/roleService';
import FaIcon from './FaIcon';

class Link extends Component {
  static defaultProps = {
    className: 'link',
    iconName: null,
    title: null,
    linktext: null,
    link: null,
    iconInTitle: true,
    iconInLinktext: true,
    tooltipText: '',
    withoutText: false,
    disabled: false,
    roleKey: null,
    dropdownmenu: false,
    menuitem: 0,
    submenuButton: 0,
    url: 'home',
    target: '_self'
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick = (e) => {
    if (this.props.target === '_blank' && this.props.url) {
      window.open(`/${this.props.url}`, '_blank');
      return;
    }
    this.props.link_click(
      this.props.link,
      this.props.title,
      this.props.iconName,
      this.props.menuitem,
      this.props.submenuButton,
      this.props.url
    );
  };

  render() {
    const enabled =
      !this.props.disabled &&
      (!this.props.roleKey || (this.props.roleKey && RoleService.CheckUserPermission('link', this.props.roleKey)));

    const showedText = this.props.linktext || this.props.linktext === '' ? this.props.linktext : this.props.title;
    const cn = enabled ? this.props.className : `${this.props.className} disabledlink`;

    if (this.props.dropdownmenu)
      return (
        <span
          className={`actionmenulink dataTabledropdownmenu ${enabled ? '' : 'dataTabledropdownmenuDisabled'}`}
          onClick={enabled ? this.onClick : null}
          disabled={!enabled}
        >
          <div
            className={`dataTabelDropdownMenubuttonStyle ${enabled ? '' : 'dataTabelDropdownMenubuttonStyleDisabled'}`}
          >
            <i className={this.props.iconName} />
          </div>
          <div
            className={`dataTabelDropdownMenubuttonStyle ${enabled ? '' : 'dataTabelDropdownMenubuttonStyleDisabled'}`}
          >
            {this.props.text}
          </div>
        </span>
      );
    return (
      <span
        className={cn}
        onClick={enabled ? this.onClick : null}
        data-toggle='tooltip'
        data-placement='top'
        title={enabled ? this.props.tooltipText : ''}
      >
        {this.props.iconInLinktext && this.props.iconName && (
          <FaIcon iconName={this.props.iconName} tooltipText={enabled ? this.props.tooltipText : ''} />
        )}
        {this.props.iconInLinktext && this.props.iconName && !this.props.withoutText && JsxHelper.NonBreakableSpace()}
        {!this.props.withoutText && showedText}
      </span>
    );
  }
}

export default connect(null, { link_click })(Link);
